import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "support-page" }
const _hoisted_2 = { class: "support-shell" }
const _hoisted_3 = { class: "support-brand" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "support-panel" }
const _hoisted_6 = { class: "support-grid" }
const _hoisted_7 = ["href", "target"]
const _hoisted_8 = { class: "support-icon" }
const _hoisted_9 = { class: "support-card-title" }
const _hoisted_10 = { class: "support-card-value" }
const _hoisted_11 = { class: "support-card-description" }
const _hoisted_12 = { class: "support-legal" }
const _hoisted_13 = { class: "support-card-legal-main" }
const _hoisted_14 = { class: "support-icon support-card-legal-icon" }
const _hoisted_15 = { class: "support-card-legal-action" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "support-story" }
const _hoisted_18 = { class: "story-showcase" }
const _hoisted_19 = { class: "story-device" }
const _hoisted_20 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "support-logo",
          src: _ctx.logoUrl,
          alt: "Prestalight"
        }, null, 8, _hoisted_4)
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("header", { class: "support-hero" }, [
        _createElementVNode("p", { class: "support-eyebrow" }, "ATENCIÓN AL CLIENTE"),
        _createElementVNode("h1", { class: "support-title" }, "Estamos aquí para ayudarte"),
        _createElementVNode("p", { class: "support-description" }, " Si tienes alguna duda o necesitas ayuda, contáctanos por el canal que prefieras. Estamos listos para echarte una mano. ")
      ], -1)),
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contacts, (item) => {
            return (_openBlock(), _createElementBlock("a", {
              key: item.title,
              class: "support-card",
              href: item.href,
              target: item.external ? '_blank' : undefined,
              rel: "noreferrer"
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_van_icon, {
                  name: item.icon
                }, null, 8, ["name"])
              ]),
              _createElementVNode("div", _hoisted_9, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(item.value), 1),
              _createElementVNode("div", _hoisted_11, _toDisplayString(item.description), 1)
            ], 8, _hoisted_7))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_12, [
        _createVNode(_component_router_link, {
          class: "support-card support-card-legal",
          to: "/privacy_policy/ios"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_van_icon, { name: "shield-o" })
              ]),
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "support-card-legal-copy" }, [
                _createElementVNode("div", { class: "support-card-title support-card-legal-title" }, " Política de privacidad "),
                _createElementVNode("div", { class: "support-card-description support-card-legal-description" }, " Consulta nuestra política de privacidad y conoce cómo protegemos tus datos personales. ")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "support-card-legal-action-text" }, "Ver acuerdo", -1)),
              _createElementVNode("img", {
                class: "support-card-legal-arrow",
                src: require('@/assets/image/ic_arrow.png'),
                alt: ""
              }, null, 8, _hoisted_16)
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("section", _hoisted_17, [
        _cache[4] || (_cache[4] = _createElementVNode("header", { class: "story-intro" }, [
          _createElementVNode("h2", { class: "story-heading" }, " More Than Credit: Our Mission, Vision & Purpose "),
          _createElementVNode("p", { class: "story-lead" }, " At Prestalight, credit is not a burden but a source of opportunity. "),
          _createElementVNode("p", { class: "story-text" }, " We strive to make finance accessible and fair, guided by transparency and empathy, with the ambition to set a new standard in Spain's microcredit market. Above all, we want credit to be positive, human, and a real ally in improving everyday life. ")
        ], -1)),
        _createElementVNode("div", _hoisted_18, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "story-copy" }, [
            _createElementVNode("h3", { class: "story-title" }, "Credit that empowers."),
            _createElementVNode("p", { class: "story-description" }, " Prestalight supports life's key moments, helping you face the unexpected, achieve your goals, and live with confidence. Borrow up to €2,000, with clarity, speed, and care. ")
          ], -1)),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("img", {
              class: "story-device-image",
              src: _ctx.mobileUrl,
              alt: "Prestalight app"
            }, null, 8, _hoisted_20)
          ]),
          _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"story-wave\" aria-hidden=\"true\" data-v-3cb9c2f7></div><div class=\"story-loop\" aria-hidden=\"true\" data-v-3cb9c2f7></div><div class=\"story-badge\" data-v-3cb9c2f7><span class=\"story-badge-label\" data-v-3cb9c2f7>Hasta</span><span class=\"story-badge-value\" data-v-3cb9c2f7>2.000 €</span></div>", 3))
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "support-footer" }, [
        _createElementVNode("h3", null, "Nébula Finance, S.A.© 2026 All Rights Reserved")
      ], -1))
    ])
  ]))
}